import { Palette, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel } from "../components/ui/dropdown-menu";

export const PRESETS = [
  ["aurora", "Aurora", ["#22d3ee", "#a78bfa", "#f472b6"]],
  ["ocean", "Ocean", ["#0ea5e9", "#6366f1", "#22d3ee"]],
  ["sunset", "Sunset", ["#fb923c", "#f43f5e", "#fbbf24"]],
  ["royal", "Royal", ["#8b5cf6", "#d946ef", "#6366f1"]],
  ["neon", "Neon", ["#a3e635", "#22d3ee", "#4ade80"]],
  ["emerald", "Emerald", ["#34d399", "#14b8a6", "#a3e635"]],
  ["violet", "Violet", ["#a78bfa", "#7c3aed", "#c4b5fd"]],
  ["sky", "Sky", ["#38bdf8", "#0ea5e9", "#818cf8"]],
  ["luxury", "Luxury", ["#C9A96E", "#b08d57", "#e8d5ae"]],
  ["modern", "Modern Gradient", ["#f472b6", "#fb7185", "#fbbf24"]],
];

export const applyPreset = (p) => {
  document.documentElement.dataset.preset = p;
  localStorage.setItem("zylo_preset", p);
};

export const initPreset = () => {
  const p = localStorage.getItem("zylo_preset") || "aurora";
  document.documentElement.dataset.preset = p;
  return p;
};

export default function PresetSwitcher({ value, onChange }) {
  const current = value || localStorage.getItem("zylo_preset") || "aurora";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="preset-switcher" title="Color preset"
          className="h-10 w-10 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors">
          <Palette className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel className="overline-label">Color preset</DropdownMenuLabel>
        {PRESETS.map(([id, name, colors]) => (
          <DropdownMenuItem key={id} data-testid={`preset-${id}`} onClick={() => onChange(id)}
            className="flex items-center gap-3 cursor-pointer">
            <span className="h-5 w-5 rounded-full border border-border shrink-0"
              style={{ background: `linear-gradient(135deg, ${colors[0]}, ${colors[1]}, ${colors[2]})` }} />
            <span className="text-sm font-semibold flex-1">{name}</span>
            {current === id && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
